import { cloneDeep, createMap, CustomLayerStyle, IDataLayerType, LayerTypeId } from "../omnia"

export type CustomLayerTypeProvider = (customTypeId: number, typeId: number) => IDataLayerType

export function setupCustomLayerTypes(types: IDataLayerType[], customStyles: CustomLayerStyle[]): CustomLayerTypeProvider {

    const getKey = (styleId: number, typeId: LayerTypeId) => `${styleId}/${typeId}`

    const typesMap = createMap(types, t => t.TypeId)

    const customTypesWithDefaults = customStyles
        .map(t => {

            const m = typesMap.get(t.TypeId)

            return {
                ...cloneDeep(m),
                ...t,
                Name: m.Name
            }


        })
        .filter(t => Boolean(t))

    const map = createMap(customTypesWithDefaults, t => getKey(t.CustomStyleId, t.TypeId))

    return (styleId: number, typeId: LayerTypeId) => {
        return map.get(getKey(styleId, typeId))
    }

}
